module.exports = __webpack_public_path__ + "static/img/section_partners_logos_grid.1514811.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/AbouttheSavior/section_partners_logos_grid.png
// module id = 2HdI
// module chunks = 1